import request from '../request'

/*
  12306账号相关接口
  331533    获取用户12306账号列表
  331534    获取12306账号信息（即登录12306接口)
  331535    删除高铁管家账号下绑定的12306账号
  331536    获取12306账号乘车人
*/

export default {
  '331533': () =>
    request.ticket({
      url: '/gateway/gtgj/daigou',
      auth: 'yes',
      data: {
        pid: 331533
      },
      sidFields: ['uid', 'pid']
    }),
  '331534': ({
      loginId,
      loginPassword
    }) =>
    request.ticket({
      url: '/gateway/gtgj/daigou',
      data: {
        pid: 331534,
        loginId,
        loginPassword
      },
      sidFields: ['uid', 'pid']
    }),
  '331535': ({
      account12306
    }) =>
    request.ticket({
      url: '/gateway/gtgj/daigou',
      auth: 'yes',
      data: {
        pid: 331535,
        account12306
      },
      sidFields: ['uid', 'pid']
    }),
  '331536': ({
      loginId,
      loginPassword
    }) =>
    request.ticket({
      url: '/gateway/gtgj/daigou',
      data: {
        pid: 331536,
        loginId,
        loginPassword
      },
      sidFields: ['uid', 'pid']
    })
}



// WEBPACK FOOTER //
// ./src/api/account12306.js